module.exports = __webpack_public_path__ + "static/pic03-3e4747259055ce41e7921867ca5ac609.jpg";